import asset from './asset';
import pages from './pages';
import section from './section';
import shows from './shows';
import movies from './movies';
import epg from './epg';

export default function v1(backendAxiosInstance) {
  return {
    ...asset(backendAxiosInstance),
    ...pages(backendAxiosInstance),
    ...section(backendAxiosInstance),
    ...shows(backendAxiosInstance),
    ...movies(backendAxiosInstance),
    ...epg(backendAxiosInstance),
  };
}
